module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Gentlemen’s Club")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1-marcia-jones"
    }
  }, [_vm._v("Chapter 1: Marcia Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-2-barnaby-brown"
    }
  }, [_vm._v("Chapter 2: Barnaby Brown")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-3-detective-inspector-james-jones"
    }
  }, [_vm._v("Chapter 3: Detective\n                Inspector James Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-4-jean-wellington"
    }
  }, [_vm._v("Chapter 4: Jean Wellington")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-5-cynthia"
    }
  }, [_vm._v("Chapter 5: Cynthia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-6-barney-and-jimmy"
    }
  }, [_vm._v("Chapter 6: Barney and Jimmy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7-aunt-jean-and-natalie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Aunt Jean and\n                Natalie")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8-detective-inspector-james-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Detective\n                Inspector James Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9-police-commissioner-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Police Commissioner\n                Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10-detective-maureen-sullivan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Detective Maureen\n                Sullivan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11-detective-inspector-james-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Detective\n                Inspector James Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-12-troy-trent-and-tyrone-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Troy, Trent,\n                and Tyrone Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-13-shirley-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Shirley Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-14-the-bennet-boys",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Bennet Boys")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-15-barnaby-and-di-james-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Barnaby and DI\n                James Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-16-maureen-and-barnaby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Maureen and Barnaby")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-17-tina-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Tina Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-18-jean-and-miriam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Jean and Miriam")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-19-maureen-and-barnaby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Maureen and Barnaby")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-20-tina-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Tina Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-21-jean",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Jean")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-22-anthony-keith-and-troy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Anthony, Keith and\n                Troy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-23-miriam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Miriam")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-24-river-stanos",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: River Stanos")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-25-ricky-paterson",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Ricky Paterson")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-26-barry-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Barry Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-27-the-gentlemens-club",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: The Gentlemen’s Club")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-28-angela-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Angela Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-29-detective-james-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Detective James\n                Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-30-the-harringtons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: The Harringtons")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-31-the-wedding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: The Wedding")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-32-rodney-harrington",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Rodney Harrington")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-33-detective-inspector-james-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Detective\n                Inspector James Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-34-barnaby-brown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Barnaby Brown")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-35-maureen-brown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Maureen Brown")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-36-keith-and-janet-sullivan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: Keith and Janet\n                Sullivan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-37-anthony-and-angela-bennet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: Anthony and Angela\n                Bennet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-38-elaine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: Elaine")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-39-janet-sullivan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: Janet Sullivan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-40-detective-inspector-james-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: Detective\n                Inspector James Jones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#chapter-41-old-joe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41: Old Joe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#chapter-42-the-school-bus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42: The School Bus")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0